import { Card, Col, Divider, Row } from 'antd';
import Title from 'antd/lib/typography/Title';
import React from 'react';
import SellersList from './SellersList';

const Sellers: React.FC = () => {
  return (
    <Row gutter={[20, 20]}>
      <Col span={24}>
        <Card>
          <Title level={5}>Parceiros</Title>
          <Divider />
          <SellersList />
        </Card>
      </Col>
    </Row>
  );
};

export default Sellers;
